import { AttendeeType } from "../../../types/block/type";
import GuestItem from "./GuestItem";
import { PositionType } from "./GuestModal";
import styles from "./GuestModal.module.css";
import clsx from "clsx";

interface GuestDropdownListProps {
  filteredGuests: AttendeeType[];
  guestDropdownRef: React.RefObject<HTMLUListElement>;
  isScrolling: boolean;
  currentActiveIndex: number;
  handleAddGuest: (email: string) => void;
  attendees: AttendeeType[];
  guestDropdownPosition: PositionType | null;
}

const GuestDropdownList = ({
  filteredGuests,
  guestDropdownRef,
  isScrolling,
  currentActiveIndex,
  handleAddGuest,
  guestDropdownPosition,
  attendees,
}: GuestDropdownListProps) => {
  return (
    <ul
      className={clsx(styles["guests-modal"], {
        [styles["showScrollbar"]]: isScrolling,
      })}
      ref={guestDropdownRef}
      style={guestDropdownPosition ?? undefined}
      onClick={(event) => event.stopPropagation()}
      onMouseDown={(event) => event.stopPropagation()}
    >
      {filteredGuests.map((guest, index) => (
        <GuestItem
          key={index}
          data={filteredGuests}
          email={guest.email}
          onClick={handleAddGuest}
          isActive={currentActiveIndex === index}
          isExistingGuest={
            attendees && attendees.some((existingGuest) => existingGuest.email === guest.email)
          }
        />
      ))}
    </ul>
  );
};

export default GuestDropdownList;
